import React from 'react';

interface TabsProps {
    tabs: string[];
    selectedTab: string;
    onClickTab: Function
}

export const Tabs: React.FC<TabsProps> = ({ tabs, selectedTab, onClickTab }) => {
    if (tabs.length < 1) {
        return null;
    }
    return (
        <div className='tabs'>
            {tabs.map(tab => (<div key={tab} className={`tab ${selectedTab === tab && 'selected'}`} onClick={() => onClickTab(tab)}>
                {tab}
            </div>))}
        </div>
    );
};
